import {catchError, filter, shareReplay, switchMap, switchMapTo, takeUntil, tap} from 'rxjs/operators';
import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, merge, Observable, Subject, throwError} from 'rxjs';

import {UserPermissionDto} from 'src/app/permission/classes/userPermissionDto.models';
import {UserAndPermissionTableService} from './user-and-permission-table.service';

export class UserAndPermissionTableDataSource extends DataSource<UserPermissionDto> {
  private destroy$ = new Subject<void>();
  private refreshData$ = this.userAndPermissionTableService.refreshData$;
  private searchOptions$ = this.userAndPermissionTableService.searchOptions$;

  private _loading$ = new BehaviorSubject<boolean>(false);
  public loading$ = this._loading$.pipe(takeUntil(this.destroy$), shareReplay(1));

  private _totalRowsCount$ = new BehaviorSubject(0);
  public totalRowsCount$ = this._totalRowsCount$.pipe(takeUntil(this.destroy$));

  public pageRows$ = merge(this.refreshData$, this.searchOptions$).pipe
  (
    switchMapTo(this.searchOptions$),
    takeUntil(this.destroy$),
    filter(searchOptions => {
      return searchOptions !== null;
    }),
    tap(() => this._loading$.next(true)),
    switchMap(searchOptions => this.userAndPermissionTableService.getPermissionsList(searchOptions)),
    tap(list => {
      this._totalRowsCount$.next(list.length);
      this._loading$.next(false);
    }),
    shareReplay(1)
  );

  constructor(
    private userAndPermissionTableService: UserAndPermissionTableService,
  ) {
    super();
  }

  connect(collectionViewer: CollectionViewer): Observable<UserPermissionDto[] | ReadonlyArray<UserPermissionDto>> {
    return this.pageRows$.pipe(
      catchError((error) => {
        this._loading$.next(false);
        return throwError(error);
      })
    );
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
